/**
 * Copyright ©2023 Drivepoint
 */

import React, {MouseEvent} from "react";
import {Button, ButtonProps} from "@mui/material";
import Logger from "../../utilities/logger/Logger";
import "./StandardButton.less";

const logger = Logger.logger;

export type StandardButtonProps = {
  label: any;
  variant?: "text" | "contained" | "outlined";
  type?: "primary" | "secondary" | "success" | "danger";
  onClick?: (event: MouseEvent) => void;
  submit?: boolean;
} & Pick<ButtonProps, "disabled" | "fullWidth">;

export default function StandardButton({label, variant = "contained", type = "primary", onClick, submit, ...rest}: StandardButtonProps): any {

  const classes = [
    "standard-button",
    `standard-button-type-${type}`,
    `standard-button-variant-${variant}`
  ];

  return <Button className={`${classes.join(" ")}`} variant={variant} onClick={onClick} type={submit ? "submit" : undefined} {...rest}>
    {label}
  </Button>;

}
